import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const container = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

// Prerendered pages ship with content already in #root — hydrate it.
if (container.children.length > 0) {
  hydrateRoot(container, app, {
    onRecoverableError(error, errorInfo) {
      console.error(error, errorInfo.componentStack)
    },
  })
} else {
  createRoot(container).render(app)
}
